<template>
  <v-card class="ma-2" outlined>

    <v-card-text class="pa-2">
      <v-row no-gutters>

        <v-col cols="12" md="4">
          <im-range
            :check_in.sync="c_check_in"
            :check_out.sync="c_check_out"
          />
        </v-col>

        <v-col cols="12" md="4">
          <im-guests
            :rooms.sync="c_rooms"
          />
        </v-col>

        <v-col cols="12" md="2">
          <v-select
            v-model="c_currency"
            class="ma-1"
            outlined
            :items="['RON','EUR']"
            type="currency"
            label="Valută"
            menu-props="offsetY"
            hide-details
          />
        </v-col>

        <v-col cols="12" md="2">
          <div class="ma-1">
            <v-btn class="primary" depressed block style="height: 56px;" @click="emitSearch()">
              <v-icon>mdi-magnify</v-icon>
              Caută
            </v-btn>
          </div>
        </v-col>

      </v-row>
    </v-card-text>

  </v-card>
</template>

<script>

  import IMRange from "../utils/IMRange";
  import IMGuests from "../utils/IMGuests";

  export default {

    components: {
      'im-range': IMRange,
      'im-guests': IMGuests,
    },

    props: {
      check_in: {
        type: String,
        default: () => null
      },
      check_out: {
        type: String,
        default: () => null
      },
      rooms: {
        type: Array,
        default: () => null,
      },
      currency: {
        type: String,
        default: () => 'RON'
      }
    },

    computed: {
      c_check_in: {
        get() {
          return this.check_in;
        },
        set(val) {
          this.$emit("update:check_in", val);
        }
      },
      c_check_out: {
        get() {
          return this.check_out;
        },
        set(val) {
          this.$emit("update:check_out", val)
        }
      },
      c_rooms: {
        get() {
          return this.rooms;
        },
        set(val) {
          this.$emit("update:rooms", val)
        }
      },
      c_currency: {
        get() {
          return this.currency;
        },
        set(val) {
          this.$emit("update:currency", val)
        }
      }
    },

    methods: {

      emitSearch() {
        this.$emit('search');
      }

    }

  }
</script>
